/**
 * A dropped connection, not a bug: the browser's fetch rejected with a
 * `TypeError` before any response arrived. Each engine words it differently
 * ("Failed to fetch" in Chrome, "Load failed" / "network error" in Safari,
 * "NetworkError when attempting to fetch resource." in Firefox).
 *
 * Error boundaries show "Connection lost" with a Retry for these instead of
 * the generic crash screen, and tag the PostHog capture `transient: true` so
 * they can be filtered out of real error-tracking issues.
 */
const TRANSIENT_NETWORK_MESSAGE =
  /network error|failed to fetch|load failed|networkerror/i;

export function isTransientNetworkError(error: unknown): boolean {
  if (!(error instanceof TypeError)) return false;
  return TRANSIENT_NETWORK_MESSAGE.test(error.message ?? "");
}
